import React, { useState } from "react";
import clsx from "clsx";
import Routes from "./Utils/Routes";

import Drawer from "@material-ui/core/Drawer";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

import { Menu as MenuIcon } from "@material-ui/icons";

import useStyles from "./Layout/styles";
import Sidebar from "./Layout/Sidebar";
import Navbar from "./Layout/Navbar";
import useToken from "./Utils/UseToken";
import SignIn from "./Pages/SignIn/SignIn";
import UserRightPanel from "./Layout/UserRightPanel";
import NotificationsRightPanel from "./Layout/NotificationsRightPanel";

export default function App() {
  const classes = useStyles();
  const { token, setToken } = useToken();

  // Sidebar
  const [open, setOpen] = useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  // Right Drawer
  const [state, setState] = useState({
    notifications: false,
    user: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) =>
    anchor === "notifications" ? (
      <div
        className={classes.list}
        role="presentation"
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <NotificationsRightPanel
          toggleDrawer={toggleDrawer}
        ></NotificationsRightPanel>
      </div>
    ) : (
      <div
        className={classes.list}
        role="presentation"
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <UserRightPanel toggleDrawer={toggleDrawer}></UserRightPanel>
      </div>
    );

  // DOCUMENTATION AND EXAMPLE: https://www.digitalocean.com/community/tutorials/how-to-add-login-authentication-to-react-applications

  // TO DO: pass a token

// if (!token) {
//   return <SignIn setToken={setToken} />;
//}

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Navbar
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        toggleDrawer={toggleDrawer}
      />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.closedMobile]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {open ? (
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          ) : (
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}
            >
              <MenuIcon />
            </IconButton>
          )}
        </div>
        <Sidebar />
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.absOpacity]: open,
        })}
      >
        <div className={classes.toolbar} />
        <div>
          {["notifications", "user"].map((anchor) => (
            <React.Fragment key={anchor}>
              <SwipeableDrawer
                anchor={"right"}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
                onOpen={toggleDrawer(anchor, true)}
              >
                {list(anchor)}
              </SwipeableDrawer>
            </React.Fragment>
          ))}
        </div>
        <Routes esempio="ciao" />
      </main>
    </div>
  );
}
